import { useFadeUp } from '../hooks/usefadeup'
import './Clientes.css'

const clientes = [
  { name: 'AGC', src: '/1 CLIENTES/AGC.png' },
  { name: 'Amiwere', src: '/1 CLIENTES/AMIWERE.png' },
  { name: 'Autral Mining', src: '/1 CLIENTES/AUTRAL MINING.png' },
  { name: 'CBE', src: '/1 CLIENTES/CBE.png' },
  { name: 'Dana Agency', src: '/1 CLIENTES/DANA AGENCY.png' },
  { name: 'Dragon Security', src: '/1 CLIENTES/DRAGON SECURITY.png' },
  { name: 'Energy Works', src: '/1 CLIENTES/ENERGY WORKS.png' },
  { name: 'GBT Dana Large', src: '/1 CLIENTES/GBT_Dana_Large.svg' },
  { name: 'Golden Security', src: '/1 CLIENTES/Golden Security, Lda_.png' },
  { name: 'Phatway', src: '/1 CLIENTES/PHATWAY.png' },
  { name: 'Temoc', src: '/1 CLIENTES/TEMOC.png' },
  { name: 'World Mobile', src: '/1 CLIENTES/WORLD MONILE.png' },
]

export default function Clientes() {
  const sectionRef = useFadeUp<HTMLElement>(700)

  return (
    <section id="clientes" className="cli" ref={sectionRef}>
      <div className="cli-container">

        {/* ── Header ── */}
        <div className="cli-header" data-fade data-fade-delay="0">
          <h2 className="cli-title">Nossos Clientes</h2>
          <p className="cli-subtitle">
            Temos o orgulho de apoiar e proteger as operações de marcas líderes no mercado moçambicano.
          </p>
        </div>

        {/* ── Grid ── */}
        <div className="cli-grid">
          {clientes.map(({ name, src }, i) => (
            <div
              key={name}
              className="cli-card"
              data-fade
              data-fade-delay={`${120 + i * 100}`}
            >
              <div className="cli-logo-wrapper">
                <img src={src} alt={`Logo ${name}`} loading="lazy" draggable={false} />
              </div>
              <span className="cli-logo-name">{name}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}
